import { render } from "./questionItem.vue?vue&type=template&id=0ec93f22&scoped=true"
import script from "./questionItem.vue?vue&type=script&lang=js"
export * from "./questionItem.vue?vue&type=script&lang=js"

import "./questionItem.vue?vue&type=style&index=0&id=0ec93f22&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/staging-package-front-survey/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec93f22"]])

export default __exports__